// Example: To understand how it works
import { ActionContext, ActionTree } from 'vuex';
//import { SET_GENERAL_MEMBER_INFORMATION } from './mutation-types';
import State from './state';
import RootState from '../../state'
import commonApiRemote from "../../../services/commonApiRemote";
import appWebConfig from '../../../../../../app.web.config';
import { GeneralInfoOfMember } from '../../../models/classes/generalInfoOfMember'
import { IDashboardRequestData } from '../../../models/interfaces/iDashboardRequestData'
import { ILocation } from '../../../models/interfaces/iLocation'
import dashboardService from '../../../services/dashboardService'
import memberProfileService from '../../../services/memberProfileService'
import nonprofitProfileService from '../../../services/nonprofitProfileService';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { IAddEditLocationsOutput } from '../../../models/interfaces/iAddEditLocationOutput';
import { INonprofitBasedOnFilterOutput } from '../../../models/interfaces/dashboard/iNonprofitBasedOnFilterOutput';
import { NonprofitBasedOnFilterOutput } from '../../../models/classes/dashboard/nonprofitBasedOnFilterOutput';
import { GetEventsOutput } from '../../../models/classes/getEventsOutput';
import humps = require('humps');
import { Fan } from '../../../models/classes/fan';
import { IFan } from '../../../models/interfaces/iFan';
import {
	SET_DASHBOARD_DATA,
	HIDE_WELCOME_CARD,
	SET_MEMBER_LOCATIONS,
	SET_MEMBER_CURRENT_LOCATION,
	COMPLETE_TASK,
	SET_PROFILE_COMPLETION,
	SET_RECOMENDED_NONPROFIT_TO_FAVORITE,
	SET_COUNT_MEMBER_OPPORTUNITY,

} from './mutation-types';
import { ISetFavoritesResponse } from "../../../models/interfaces/iSetFavoritesResponse";
import { SET_FAVORITES } from "../nonprofit/mutation-types";

const eventsNamespace: string = 'events/';
const upcomingEventsAction: string = eventsNamespace + 'getUpcomingEventsData';

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {
	getDashboardData({ commit, state }: ActionContext<State, RootState>): void {
		dashboardService.getDashboardData().then((rsp: any) => {
			commit(SET_DASHBOARD_DATA, camelizer.convert(rsp.data.dashboard));
		});
	},

	nonprofitsBasedOnFilter({ commit }: ActionContext<State, RootState>, data: INonprofitBasedOnFilterOutput): Promise<any> {
		return new Promise((resolve, reject) => {
			dashboardService.getNonprofitsBasedOnFilter(data).then((rsp: any) => {
				const camelizedData = camelizer.convert(rsp.data);
				resolve(camelizedData);
			});
		});
	},

	hideWelcomeCard({ commit }: ActionContext<State, RootState>): Promise<any> {
		return new Promise((resolve, reject) => {
			dashboardService.hideWelcomeCard().then((rsp: any) => {
				commit(HIDE_WELCOME_CARD);
				resolve(rsp.data);
			});
		});
	},

	setMemberLocations({ commit, dispatch }: ActionContext<State, RootState>, data: IAddEditLocationsOutput) {
		return new Promise((resolve, reject) => {
			memberProfileService.setMemberLocations(data).then((rsp: any) => {
				const locations = camelizer.convert(rsp.data.locations);
				const basedOnFilterOutput = new NonprofitBasedOnFilterOutput({
					page: 1,
					filter: 'All',
				});
				const eventsOutput = new GetEventsOutput({
					orgKey: '',
					eventType: 'All',
					isAts: false,
				});

				commit(SET_MEMBER_LOCATIONS, locations);
				dispatch(upcomingEventsAction, eventsOutput, { root: true });
				dispatch('nonprofitsBasedOnFilter', basedOnFilterOutput);
				resolve(rsp.data);
			});
		});
	},

	setMemberCurrentLocation({ dispatch }: ActionContext<State, RootState>, data: string) {
		return new Promise((resolve, reject) => {
			memberProfileService.setMemberCurrentLocation(data).then((rsp: any) => {
				const basedOnFilterOutput = new NonprofitBasedOnFilterOutput({
					page: 1,
					filter: 'All',
				});
				const eventsOutput = new GetEventsOutput({
					orgKey: '',
					eventType: 'All',
					isAts: false,
				});

				dispatch(upcomingEventsAction, eventsOutput, { root: true });
				dispatch('nonprofitsBasedOnFilter', basedOnFilterOutput);
				resolve(rsp.data);
			});
		});
	},

	completeTask({ commit, dispatch }: ActionContext<State, RootState>, type: string) {
        return new Promise((resolve, reject) => {
            // debugger;
            dashboardService.completeTask(type).then((rsp: any) => {
                // debugger;
                const camelizedData: any = camelizer.convert(rsp.data);
                commit(COMPLETE_TASK, camelizedData.nextTask);

                dispatch('incrementProfileCompletion', type);

				resolve(rsp.data);
			});
		});
	},

	incrementProfileCompletion({ commit }: ActionContext<State, RootState>, type: string) {
		return new Promise((resolve, reject) => {
			commit(SET_PROFILE_COMPLETION, type);
			resolve(true);
		});
	},
	
	setFavorites({ commit }: ActionContext<State, RootState>, orgKey: string): Promise<any> {
		return new Promise((resolve, reject) => {
			nonprofitProfileService.setFavorites(orgKey)
				.then((res: any) => {
					const data = <ISetFavoritesResponse>camelizer.convert(res.data);
					const fan: IFan = new Fan({ isFan: data.isFan, orgKey: data.orgKey });
					commit(SET_FAVORITES, data.nonprofit);
					resolve(fan);
				})
				.catch((error: any) => reject(error));
			});
		},
		
		async setRecomendedNonprofitToFavorite({ commit }: ActionContext<State, RootState>, data: IFan): Promise<any> {
			return commit(SET_RECOMENDED_NONPROFIT_TO_FAVORITE, data);
		},

		async getCountShortlistOnOpportunity({ commit }: ActionContext<State, RootState>, key: string): Promise<any> {
			return new Promise((resolve, reject) => {
				dashboardService.getCountShortlistOnOpportunity(key).then((rsp: any) => {
					const camelizedData: any = camelizer.convert(rsp.data);
					const count = camelizedData.count;
					commit(SET_COUNT_MEMBER_OPPORTUNITY, count);
					resolve(count);
				});
			});
		}
		
		//getGeneralInfomrationOfMember({ commit, dispatch }: ActionContext<State, RootState>, data: any): void {
			//	debugger;
			//	commonApiRemote(appWebConfig.private.database.generalInfoOfMember).getData().then((rsp: any) => {
				//		debugger;
				//		let generalInfoOfMember:any = humps.camelizeKeys(rsp.data);
				
				//		dispatch('setGeneralInfomrationOfMember', new GeneralInfoOfMember(generalInfoOfMember), { root: true});
				//	});
				//   }
			};
			

			export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/dashboard/actions.ts